module.exports = __webpack_public_path__ + "static/media/Lens-Fresh_Grayzel_HK.caaf4cb2.png";